import type { OrderStatus } from 'types/orders';
import type { UserStatus } from 'types/users';
import type { CarStatus } from 'store/slices/cars/types';
import type { Categories } from 'store/slices/cars/types';

export enum AppRoutes {
  HOME = '/',
  ECOLOGY = '/ecology',
  RESERVATION = '/reservation',
  ADMIN = '/admin',
  CLIENT_DASHBOARD = '/client-dashboard',
  CONFIRM_ACCOUNT = '/confirm-account',
  SUBSCRIPTIONS = '/subscriptions',
  SUBSCRIBE = '/subscribe',
  ABOUT_US = '/about-us',
  CONTACT_US = '/CONTACT_US',
  RESET_PASSWORD = '/reset-password',
  SEARCH = '/search',
  EMAIL_VERIFICATION = '/email-verification',
  CONFIRM_ORDER_PAYMENT = '/confirm-payment',
}

export type Status = OrderStatus | UserStatus | CarStatus;

export enum ReservationFiltersQueryKeys {
  AVAILABILITY = 'dateRange',
  MAX_PRICE = 'maxPrice',
  CATEGORY = 'category',
}

export interface CarCategoryCardItem {
  id: string;
  title: string;
  key: Categories;
  bgImage: string;
}
